export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_IS_NICKNAME_CHECK_EXIST_REQUEST_STATUS =
    'SET_IS_NICKNAME_CHECK_EXIST_REQUEST_STATUS';
export const POST_CHECK_NICKNAME_SUCCESS = 'POST_CHECK_NICKNAME_SUCCESS';
export const GET_MALL_COUNTRIES_SUCCESS = 'GET_MALL_COUNTRIES_SUCCESS';
//
export const GET_WECHAT_QRCODE_SUCCESS = 'GET_WECHAT_QRCODE_SUCCESS';
//
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
